import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LoginSignupService } from 'src/app/shared/services/node-api/login-signup.service';
import { TansactionService } from 'src/app/shared/services/node-api/tansaction.service';

@Component({
  selector: 'app-transaction-pending-component',
  templateUrl: './transaction-pending-component.component.html',
  styleUrls: ['./transaction-pending-component.component.scss'],
})
export class TransactionPendingComponentComponent implements OnInit {
  id: any;
  transactionData: any;
  reloadPage: string;
  user: {
    user: {
      role: string;
      email: string;
      userId: string;
      mobile: string;
      token: string;
      name: string;
      onSession: string;
      plan: string;
    };
  };
  constructor(
    private activatedRoute: ActivatedRoute,
    private transactionService: TansactionService,
    private loginSignupService: LoginSignupService
  ) {
    this.user = this.loginSignupService.getUserSession();
    this.activatedRoute.params.subscribe((data) => {
      this.id = data.id;
      var val = {
        orderId: data.id,
      };
      this.transactionService.verifyCart(val).then((data: any) => {
        if (data.data != null) {
          this.transactionData = data.data;
        }
      });
    });
  }

  ngOnInit(): void {}
}
